import PropTypes from "prop-types";
import dayjs from "dayjs";
import {
  PopContainer,
  PopContainerItemWrapper,
  PopContainerLabel,
  PopContainerItem,
  HorizondalLine,
} from "../TabView/TabViewStyled";
import { resolveEntityNameOr } from "../../utils/matterFields";
import EfolderPullBadge from "../MatterDashboard/EfolderPullBadge";

const matterEntityField = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    Name: PropTypes.string,
  }),
]);

const MatterDetailsPopup = ({ matterDetails }) => {
  if (!matterDetails) return null;

  return (
    <PopContainer>
      <PopContainerItemWrapper>
        <PopContainerLabel>
          {matterDetails?.matter_displayName}
        </PopContainerLabel>
      </PopContainerItemWrapper>

      <PopContainerItemWrapper>
        <PopContainerItem>
          Status -{" "}
          <div className={matterDetails?.status === "Open" ? "open" : "closed"}>
            {matterDetails?.status}
          </div>
        </PopContainerItem>
        <HorizondalLine />
        <PopContainerItem>
          {resolveEntityNameOr(matterDetails?.case_type)}
        </PopContainerItem>
        <HorizondalLine />
        <PopContainerItem>{matterDetails?.practice_area}</PopContainerItem>
        <HorizondalLine />
      </PopContainerItemWrapper>

      <PopContainerItemWrapper>
        <PopContainerItem>
          Created on - {dayjs(matterDetails?.created_on).format("DD MMM YYYY")}
        </PopContainerItem>
        <HorizondalLine />
        <PopContainerItem data-testid="case-manager-item">
          Case Manager - {resolveEntityNameOr(matterDetails?.case_manager)}
        </PopContainerItem>
        <HorizondalLine />
      </PopContainerItemWrapper>

      <PopContainerItemWrapper>
        <PopContainerItem data-testid="principal-attorney-item">
          Principal Attorney -{" "}
          {resolveEntityNameOr(matterDetails?.principal_attourney)}
          <HorizondalLine />
        </PopContainerItem>
      </PopContainerItemWrapper>

      {/* Renders nothing until the matter has had an eFolder pull (spec 9.3). */}
      <EfolderPullBadge matterId={matterDetails?.id} matter={matterDetails} />
    </PopContainer>
  );
};

MatterDetailsPopup.propTypes = {
  matterDetails: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    matter_displayName: PropTypes.string,
    status: PropTypes.string,
    case_type: matterEntityField,
    practice_area: PropTypes.string,
    created_on: PropTypes.string,
    case_manager: matterEntityField,
    principal_attourney: matterEntityField,
  }),
};

export default MatterDetailsPopup;
